import { render, staticRenderFns } from "./QuillEditor.vue?vue&type=template&id=c0ffc06a"
import script from "./QuillEditor.vue?vue&type=script&lang=js"
export * from "./QuillEditor.vue?vue&type=script&lang=js"
import style0 from "./QuillEditor.vue?vue&type=style&index=0&id=c0ffc06a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports